import n from "./td-longtail-vue-components170.js";
/* empty css                              */
import s from "./td-longtail-vue-components98.js";
var l = function() {
  var a = this, e = a._self._c, t = a._self._setupProxy;
  return e("div", { staticClass: "controls", class: { "controls--hide-pages": a.hidePages, "controls--hide-pages-mobile": a.hidePagesMobile } }, [a.hasPlayPause ? e("div", { staticClass: "controls__play-pause" }, [e(t.PlayPauseButton, { attrs: { primary: a.primary, secondary: a.secondary, "aria-label": t.internalIsPlaying ? `${a.playPauseAriaLabel} pausieren` : `${a.playPauseAriaLabel} abspielen` }, on: { input: (i) => a.$emit("input", i) }, model: { value: t.internalIsPlaying, callback: function(i) {
    t.internalIsPlaying = i;
  }, expression: "internalIsPlaying" } })], 1) : a._e(), e(t.CarouselNavigation, { staticClass: "controls__pagination", attrs: { pages: a.pages, "aria-label": a.paginationAriaLabel, infinity: a.infinityScroll, "hide-pages": a.hidePages, "hide-pages-mobile": a.hidePagesMobile, "label-next": a.paginationNext, "label-prev": a.paginationPrev, "button-label": a.paginationButtonLabel, "button-label-first": a.paginationButtonLabelFirst, "button-label-last": a.paginationButtonLabelLast, "do-not-scroll-into-view": a.doNotScrollIntoView, primary: a.primary, secondary: a.secondary }, on: { update: (i) => a.$emit("update", i) } }), a.hasPlayPause ? e("div", { staticClass: "controls__spacer" }) : a._e()], 1);
}, o = [], r = /* @__PURE__ */ s(
  n,
  l,
  o,
  !1,
  null,
  "60bf24aa"
);
const d = r.exports;
export {
  d as default
};
